module.exports = function object ({ hash }) {
  return hash;
}
